import React from 'react';
import { useLocation } from 'react-router-dom';

// @material-ui
import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import * as http from '_core/utils/http';

// style
import { useStyle } from './style';


/*
  slots.jsx
    import { Iframe } from '_core/components/Iframe';
    import { Props } from 'basic/slots';
    
    Props(Iframe, { height: 'calibrate', src: '/iframe.html' })
  
  iframe.html:
    <script src="/data/jscript/global/calibrate-height.js"></script>
*/


let iframeID = 0;

const iframeHandlers = {};

export const RawIframe = (props) => {
  const { width, height, src } = props;
  
  const [id, setID] = React.useState();
  const [calibrateHeight, setCalibrateHeight] = React.useState();
  
  const { pathname } = useLocation();
  
  const { pages: { iframes } } = useTheme();
  
  const classes = useStyle();
  
  const iframeSrc = src || iframes[pathname];
  
  React.useEffect(() => {
    const genID = ++iframeID;
    
    iframeHandlers[genID] = setCalibrateHeight;
    
    setID(genID);
    
    return () => delete iframeHandlers[genID];
  }, [iframeSrc]);
  
  
  const iframeStyle = {};
  
  if (typeof width !== 'undefined')
    iframeStyle.width = width;
  
  if (height === 'calibrate') {
    iframeStyle.height = calibrateHeight;
  } else if (typeof height !== 'undefined') {
    iframeStyle.height = height;
  }
  
  return id ? (
    <Box display="flex" className={height !== 'calibrate' ? classes.root : null}>
      <iframe src={height === 'calibrate' ? http.param(iframeSrc, { 'calibrate-id': id }) : iframeSrc} className={classes.iframe} style={iframeStyle} />
    </Box>
  ) : null;
};

RawIframe.defaultProps = {};

RawIframe.propTypes = {};

export const Iframe = RawIframe;


const onMessage = (event) => {
  const { type, id, value } = event.data;
  
  if (type !== 'calibrate-height')
    return;
  
  const setCalibrateHeight = iframeHandlers[id];
  
  if (!setCalibrateHeight)
    return;
  
  setCalibrateHeight(value);
}

if (window.addEventListener) {
  window.addEventListener('message', onMessage, false);        
} else if (window.attachEvent) {
  window.attachEvent('onmessage', onMessage, false);
}
